import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild
} from '@angular/core';
import { User } from 'src/app/shared/models/user.model';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import { InvitesService } from '../invites.service';
import { SharedService } from 'src/app/shared/shared.service';
declare var $;
declare var jQuery;
@Component({
  selector: 'app-invites',
  templateUrl: './invites.component.html',
  styleUrls: ['./invites.component.css']
})
export class InvitesComponent implements OnInit, AfterViewInit {
  selectedRole: any;
  inviteForm: DVFormGroup;
  roles: Array<any>;
  role: any;
  isAddState = true;
  @ViewChild('multiSelect', { static: false }) multiSelect;

  constructor(
    private invitesApi: InvitesService,
    private sharedApi: SharedService,
    private notifier: SnotifyService,
    private router: Router
  ) {}

  ngAfterViewInit() {}

  ngOnInit() {
    this.inviteForm = new DVFormGroup({
      email: new DVFormControl(null, {
        'Email is required': Validators.required,
        'Email is not in a valid format': Validators.email
      }),
      roleId: new DVFormControl(null, {
        'Roles is required': Validators.required
      })
    });
    this.sharedApi.getRoles().subscribe((res: any) => {
      // console.log(res)
      this.role = res.data.roles;
      this.role = this.role.filter(x => x.assignable === true);
      // console.log(this.role);
    });
  }

  sendInvite() {
    // console.log(this.inviteForm)
    if (this.inviteForm.valid) {
      this.invitesApi.invitation(this.inviteForm.value).subscribe(
        Response => {
          // console.log(Response)
          this.inviteForm.reset();
          this.notifier.success('Invitation Send Successfully');
          this.router.navigateByUrl('/settings/invites/list');
        },
        error => {
          // console.log(error);

          this.notifier.error(error.error.userMessage);
          this.inviteForm.controls[`email`].reset();
        }
      );
    } else {
      this.inviteForm.forceShowErrors();
    }
  }
}

export interface Row {
  user: User;
  token: string;
}
